export interface SemifinishedRow {
  id?: string | number;
  product_id?: string | number;
  semifinished_product_id: string | number;
  consumption_percent: any;
  name?: string;
}

export interface SemifinishedRelationsDiff {
  toCreate: SemifinishedRow[];
  toUpdate: SemifinishedRow[];
  toDelete: SemifinishedRow[];
}

function percentsEqual(a: any, b: any): boolean {
  const na = Number(a);
  const nb = Number(b);

  if (Number.isNaN(na) || Number.isNaN(nb)) {
    return a === b;
  }

  return na === nb;
}

/**
 * Diff строк состава полуфабрикатов для many-relation сохранения.
 * Строки сопоставляются по semifinished_product_id: строка без пары в saved —
 * создание; saved без пары в current — удаление; совпавшая строка с изменившимся
 * consumption_percent — обновление (к строке подтягивается сохранённый id).
 */
export function buildSemifinishedRelationsDiff(
  savedRows: SemifinishedRow[],
  currentRows: SemifinishedRow[]
): SemifinishedRelationsDiff {
  const saved = savedRows || [];
  const current = currentRows || [];

  const savedByProduct = new Map<string | number, SemifinishedRow>();
  saved.forEach((row: SemifinishedRow) => {
    savedByProduct.set(row.semifinished_product_id, row);
  });

  const currentProductIds = new Set<string | number>();
  current.forEach((row: SemifinishedRow) => {
    currentProductIds.add(row.semifinished_product_id);
  });

  const toCreate: SemifinishedRow[] = [];
  const toUpdate: SemifinishedRow[] = [];

  current.forEach((row: SemifinishedRow) => {
    const savedRow = savedByProduct.get(row.semifinished_product_id);

    if (!savedRow) {
      toCreate.push(row);
      return;
    }

    if (!percentsEqual(savedRow.consumption_percent, row.consumption_percent)) {
      toUpdate.push({ ...row, id: savedRow.id });
    }
  });

  const toDelete: SemifinishedRow[] = saved.filter(
    (row: SemifinishedRow) => !currentProductIds.has(row.semifinished_product_id)
  );

  return { toCreate, toUpdate, toDelete };
}
